import { Component, EventEmitter, Injectable, Input } from '@angular/core';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, MatProgressSpinnerDefaultOptions } from '@angular/material/progress-spinner';
/**
 * spinner���񂷂��߂̃I�[�o�[���C�h�p�B
 */
@Injectable()
export class MatProgressSpinnerOptions implements MatProgressSpinnerDefaultOptions {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  public _forceAnimations = true;
}

@Component({
    selector: 'app-common-spinner',
    templateUrl: './common-spinner.component.html',
    styleUrls: ['./common-spinner.component.scss'],
    providers: [
        { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useClass: MatProgressSpinnerOptions }
    ],
    standalone: false
})
export class CommonSpinnerComponent {
  @Input() public isProcessing = new EventEmitter<boolean>();
  @Input() public isLightOverLay = new EventEmitter<boolean>();
}
